import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class TokenizationService {
	constructor() {}

	cleanText(string_: string): string {
		return string_.replaceAll(/[!#$%&()*,./:;=^_`{}~\-]/g, ' ').trim();
	}

	tokenization(string_: string, grams: number): string[] {
		string_ = this.cleanText(string_);
		const array = string_.split(' ');
		const tokens: string[] = [];
		if (array.length <= grams) return array;

		for (let index = 0; index <= array.length; index++) {
			if (!array[index + grams - 1]) break;
			let newToken = '';
			for (let index_ = 0; index_ < grams; index_++) {
				newToken += array[index + index_] + ' ';
			}

			newToken = newToken.trimEnd();
			tokens.push(newToken);
		}

		return tokens;
	}

	sumarization(string_: string): object {
		string_ = this.cleanText(string_);
		const array = string_.split(' ');
		const object: object = {};
		for (const [index, token] of array.entries()) {
			object[token] = index;
		}

		return object;
	}

	//Limpeza de ruído (e, ou, que, etc etc)

	//Lemmatization (Carregando => Carrega, Carregar => Carrega, Carrega => Carrega, etc etc)
	//Stemming (Pedregulho => Pedra, esqueci a palavra)
}
